import { BaseModel } from "sjs-base-model";

export default class ContractModel extends BaseModel {
    id = 0;
    bpId = 0;
    customerName = "";
    contractTypeId = 0;
    contractTypeName = "";
    clmMaNumber = "";
    contractProductId = 0;
    contractProductName = "";
    affiliates = null;
    timeSeriesFrom = null;
    timeSeriesTo = null;
    remark = null;
    startDate = null;
    endDate = null;

    constructor(data) {
        super();
        this.update(data);
    }
}
